export const MAX_BOOKING_LENGTH = 120;
